export const MODAL_TYPES = {
    newTopic: 'newTopic',
    edit: 'edit',
    newSubTopic: 'newSubTopic'
};

export default MODAL_TYPES;



// WEBPACK FOOTER //
// ./app/components/course-creator/constants.js